module.exports = __webpack_public_path__ + "img/PersonalData.c55ff381.svg";